
class Task {
  
  /**
   *  Wait for next operation
   * @param {Number | String} interval 
   */
  static Wait(interval){
    return new Promise(res => {
      setTimeout(res, parseInt(interval));
    });
  }

  /**
   *  Call and wait
   * @param {Promise} method 
   * @param {Number | String} interval 
   */
  static async CallAndWait(method, interval){
    const [result] = await Promise.all([
      method(),
      this.Wait(interval)
    ]);
    return result;
  }

  /**
   *  Call or wait for method to run
   * @param {Promise} method 
   * @param {Number | String} interval 
   */
  static async CallOrWait(method, interval){
    const result = await Promise.race([
      method(),
      this.Wait(interval).then(()=>{
        throw new Error("Timeout after " + (interval/10000) + "s");
      })
    ]);
    return result;
  }

  /**
   *  Retry Promise for n times at specified interval
   * @template T
   * @param {() => Promise<T>} method 
   * @param {(res: T) => Boolean} checkError
   * @param {Number} times 
   * @param {Number} interval 
   * @returns {Promise<T>}
   */
  static async Retry(method, checkError = null, times = 5, interval = 1000){
    try {
      const res = await method();
      if(checkError){
        if(checkError(res)){
          if (times > 1) {
            throw Error();
          }else{
            return res;
          }
        }
      }
      return res;
    } catch (e) {
      if (times > 1) {
        await this.Wait(interval);
        return this.Retry(method, checkError, times - 1, interval);
      }
      throw e;
    }
  }
}

export default Task;